var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-stage-container front-stage layout-grid",class:[_vm.columnClass]},[(!_vm.isPractice)?_c('Feedback'):_vm._e(),(_vm.isBreakout)?_c('Breakout'):_c('Content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }